<template>
  <div id="shuwoon" class="shuwoon mx-auto pt-6">
    <div class="banner px-2">
      <img src="~@/assets/images/SHUWOON/banner.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/SHUWOON/bannerM.png" class="object-contain mx-auto md:hidden">
    </div>
    <div class="flex justify-center mb-10 relative md:static px-2">
      <div class="advantage_img md:mr-3 absolute md:static"><img src="~@/assets/images/SHUWOON/con-T.png" class="object-contain mx-auto"></div>
      <div class="flex flex-wrap items-center justify-center bg-light-blue pl-12 ml-6 md:pl-0 md:ml-0">
        <div class="w-1/2 md:w-1/4 bg-light-blue p-4"><img src="~@/assets/images/SHUWOON/con1.png" class="object-contain mx-auto"></div>
        <div class="w-1/2 md:w-1/4 bg-light-blue p-4"><img src="~@/assets/images/SHUWOON/con2.png" class="object-contain mx-auto"></div>
        <div class="w-1/2 md:w-1/4 bg-light-blue p-4"><img src="~@/assets/images/SHUWOON/con3.png" class="object-contain mx-auto"></div>
        <div class="w-1/2 md:w-1/4 bg-light-blue p-4"><img src="~@/assets/images/SHUWOON/con4.png" class="object-contain mx-auto"></div>
      </div>
    </div>

    <div class="shadow_line w-full h-4 hidden md:block z-20 mb-1"></div>

    <div class="plan1 max-w-scoped mx-auto flex items-stretch mb-20 md:mb-24 px-2">
      <div class="left_line flex flex-col relative w-16 md:w-24">
        <div class="absolute left_line_class"><img src="~@/assets/images/SHUWOON/classN5N3.png" class="object-contain mx-auto"></div>
        <div class="absolute left_line_title"><img src="~@/assets/images/SHUWOON/video_title.png" class="object-contain mx-auto"></div>
      </div>
      <div class="plan1_inner flex-1 h-auto">
        <div class="flex flex-col md:flex-row mb-4 pt-4 ml-3 md:ml-0">
          <div class="mr-3 mb-2 md:mb-0"><img src="~@/assets/images/SHUWOON/title01.png" class="object-contain md:mx-auto"></div>
          <div class=""><img src="~@/assets/images/SHUWOON/title01_solgan.png" class="object-contain md:mx-auto"></div>
        </div>
        <div class="flex flex-col md:flex-row mb-4 px-3">
          <div class="mr-4 mb-4 md:mb-0"><img src="~@/assets/images/SHUWOON/img01.png" class="object-contain"></div>
          <div class="">
            <img src="~@/assets/images/SHUWOON/img01_text.png" class="object-contain mx-auto hidden md:block">
            <img src="~@/assets/images/SHUWOON/img01_text_m.png" class="object-contain md:hidden">
          </div>
        </div>
        <div class="flex flex-wrap">
          <div class="w-full md:w-1/2 px-3 mb-4">
            <div class="mr-4 mb-4"><img src="~@/assets/images/SHUWOON/film01_1.png" class="object-contain md:mx-auto"></div>
            <iframe width="100%" height="270" src="https://www.youtube.com/embed/BR1aaTlGlHY?si=U0APwNm5cNd_cBF8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-4">
            <div class="mr-4 mb-4"><img src="~@/assets/images/SHUWOON/film01_2.png" class="object-contain md:mx-auto"></div>
            <iframe width="100%" height="270" src="https://www.youtube.com/embed/q1Wa2EWlSlo?si=f9kB3wKAZbKWN-WX" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-4">
            <router-link :to="{ name: 'detail', params: { category: 'magazine', id: 9544 } }" target="_blank" class=""><img src="~@/assets/images/SHUWOON/shop1_1.png" class="object-contain mx-auto"></router-link>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-4">
            <router-link :to="{ name: 'detail', params: { category: 'magazine', id: 9543 } }" target="_blank" class=""><img src="~@/assets/images/SHUWOON/shop1_2.png" class="object-contain mx-auto"></router-link>
          </div>
        </div>
        <router-link :to="{ name: 'detail', params: { category: 'magazine', id: 9543 } }" target="_blank" class="mt-4"><img src="~@/assets/images/SHUWOON/more.png" class="object-contain"></router-link>
      </div>
    </div>
    <div class="plan2 max-w-scoped mx-auto flex items-stretch mb-20 md:mb-24 px-2">
      <div class="left_line flex flex-col relative w-16 md:w-24">
        <div class="absolute left_line_class"><img src="~@/assets/images/SHUWOON/classN5N3.png" class="object-contain mx-auto"></div>
        <div class="absolute left_line_title"><img src="~@/assets/images/SHUWOON/video_title.png" class="object-contain mx-auto"></div>
      </div>
      <div class="plan2_inner flex-1 h-auto">
        <div class="flex flex-col md:flex-row mb-4 pt-4 ml-3 md:ml-0">
          <div class="mr-3 mb-2 md:mb-0"><img src="~@/assets/images/SHUWOON/title02.png" class="object-contain md:mx-auto"></div>
          <div class="">
            <img src="~@/assets/images/SHUWOON/title02_solgan.png" class="object-contain md:mx-auto hidden md:block">
            <img src="~@/assets/images/SHUWOON/title02_solgan_m.png" class="object-contain md:mx-auto md:hidden">
          </div>
        </div>
        <div class="flex flex-col md:flex-row mb-4 px-3">
          <div class="mr-4 mb-4 md:mb-0"><img src="~@/assets/images/SHUWOON/img02.png" class="object-contain"></div>
          <div class="">
            <img src="~@/assets/images/SHUWOON/img02_text.png" class="object-contain mx-auto hidden md:block">
            <img src="~@/assets/images/SHUWOON/img02_text_m.png" class="object-contain md:hidden">
          </div>
        </div>
        <div class="flex flex-wrap">
          <div class="w-full md:w-1/2 px-3 mb-4 md:mb-0">
            <div class="mr-4 mb-4"><img src="~@/assets/images/SHUWOON/film02_1.png" class="object-contain md:mx-auto"></div>
            <iframe width="100%" height="270" src="https://www.youtube.com/embed/KSDm5fGgXeg?si=sIsDoTXjCXUPrGwi" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            <!-- <div class="mr-4 mt-4"><img src="~@/assets/images/SHUWOON/shop1_1.png" class="object-contain mx-auto"></div> -->
          </div>
          <div class="w-full md:w-1/2 px-3">
            <div class="mr-4 mb-4"><img src="~@/assets/images/SHUWOON/film02_2.png" class="object-contain md:mx-auto"></div>
            <iframe width="100%" height="270" src="https://www.youtube.com/embed/FRl89TAvi04?si=n-sGKdbaZ2Ik7Eyr" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            <!-- <div class="mr-4 mt-4"><img src="~@/assets/images/SHUWOON/shop1_2.png" class="object-contain mx-auto"></div> -->
          </div>
          <router-link :to="{ name: 'detail', params: { category: 'magazine', id: 9545 } }" target="_blank"  class="w-full px-3 md:flex items-center">
            <div class="mr-4 mt-4"><img src="~@/assets/images/SHUWOON/shop2_1.png" class="object-contain hidden md:block"></div>
            <div class="mr-4 mt-4 "><img src="~@/assets/images/SHUWOON/shop2_1_m.png" class="object-contain md:hidden"></div>
            <div class="mt-4"><img src="~@/assets/images/SHUWOON/more.png" class="object-contain"></div>
          </router-link>
        </div>
        <!-- <div class="mt-4"><img src="~@/assets/images/SHUWOON/more.png" class="object-contain"></div> -->
      </div>
    </div>
    <div class="plan3 max-w-scoped mx-auto flex items-stretch mb-20 md:mb-24 px-2">
      <div class="left_line flex flex-col relative w-16 md:w-24">
        <div class="absolute left_line_class"><img src="~@/assets/images/SHUWOON/classN5N3.png" class="object-contain mx-auto"></div>
        <div class="absolute left_line_title"><img src="~@/assets/images/SHUWOON/video_title.png" class="object-contain mx-auto"></div>
      </div>
      <div class="plan3_inner flex-1 h-auto">
        <div class="flex flex-col md:flex-row mb-4 pt-4 ml-3 md:ml-0">
          <div class="mr-3 mb-2 md:mb-0"><img src="~@/assets/images/SHUWOON/title03.png" class="object-contain md:mx-auto"></div>
          <div class=""><img src="~@/assets/images/SHUWOON/title03_solgan.png" class="object-contain md:mx-auto"></div>
        </div>
        <div class="flex flex-col md:flex-row mb-4 px-3">
          <div class="mr-4 mb-4 md:mb-0"><img src="~@/assets/images/SHUWOON/img03.png" class="object-contain"></div>
          <div class="">
            <img src="~@/assets/images/SHUWOON/img03_text.png" class="object-contain mx-auto hidden md:block">
            <img src="~@/assets/images/SHUWOON/img03_text_m.png" class="object-contain md:hidden">
          </div>
        </div>
        <div class="flex flex-wrap">
          <div class="w-full md:w-1/2 px-3 mb-4 md:mb-0">
            <div class="mr-4 mb-4"><img src="~@/assets/images/SHUWOON/film03_1.png" class="object-contain md:mx-auto"></div>
            <iframe width="100%" height="270" src="https://www.youtube.com/embed/1lYREddaFaA?si=OUT1sBXegKJz-dpt" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            <!-- <div class="mr-4 mt-4"><img src="~@/assets/images/SHUWOON/shop1_1.png" class="object-contain mx-auto"></div> -->
          </div>
          <div class="w-full md:w-1/2 px-3">
            <div class="mr-4 mb-4 hidden md:block opacity-0"><img src="~@/assets/images/SHUWOON/film03_1.png" class="object-contain md:mx-auto"></div>
            <div>
              <router-link :to="{ name: 'detail', params: { category: 'magazine', id: 9546 } }" target="_blank" class="block"><img src="~@/assets/images/SHUWOON/shop3_1.png" class="object-contain mx-auto"></router-link>
              <!-- <div class="mr-4 mt-4"><img src="~@/assets/images/SHUWOON/shop3_1.png" class="object-contain mx-auto"></div> -->
              <router-link :to="{ name: 'detail', params: { category: 'magazine', id: 9546 } }" target="_blank" class="mt-4 block"><img src="~@/assets/images/SHUWOON/more.png" class="object-contain"></router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="plan4 max-w-scoped mx-auto flex items-stretch mb-20 md:mb-24 px-2">
      <div class="left_line flex flex-col relative w-16 md:w-24">
        <div class="absolute left_line_class"><img src="~@/assets/images/SHUWOON/classN4N3.png" class="object-contain mx-auto"></div>
        <div class="absolute left_line_title"><img src="~@/assets/images/SHUWOON/video_title.png" class="object-contain mx-auto"></div>
      </div>
      <div class="plan4_inner flex-1 h-auto">
        <div class="flex flex-col md:flex-row mb-4 pt-4 ml-3 md:ml-0">
          <div class="mr-3 mb-2 md:mb-0"><img src="~@/assets/images/SHUWOON/title04.png" class="object-contain md:mx-auto"></div>
          <div class=""><img src="~@/assets/images/SHUWOON/title04_solgan.png" class="object-contain md:mx-auto hidden md:block"></div>
          <div class=""><img src="~@/assets/images/SHUWOON/title04_solgan_m.png" class="object-contain md:mx-auto md:hidden"></div>
        </div>
        <div class="flex flex-col md:flex-row mb-4 px-3">
          <div class="mr-4 mb-4 md:mb-0"><img src="~@/assets/images/SHUWOON/img04.png" class="object-contain"></div>
          <div class="">
            <img src="~@/assets/images/SHUWOON/img04_text.png" class="object-contain mx-auto hidden md:block">
            <img src="~@/assets/images/SHUWOON/img04_text_m.png" class="object-contain md:hidden">
          </div>
        </div>
        <div class="flex flex-wrap">
          <div class="w-full md:w-1/2 px-3 mb-4 md:mb-0">
            <div class="mr-4 mb-4"><img src="~@/assets/images/SHUWOON/film04_1.png" class="object-contain md:mx-auto"></div>
            <iframe width="100%" height="270" src="https://www.youtube.com/embed/mAw_4YXzfSc?si=fE3WwuMSVU6knkHq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            <!-- <div class="mr-4 mt-4"><img src="~@/assets/images/SHUWOON/shop1_1.png" class="object-contain mx-auto"></div> -->
          </div>
          <div class="w-full md:w-1/2 px-3">
            <div class="mr-4 mb-4"><img src="~@/assets/images/SHUWOON/film04_2.png" class="object-contain md:mx-auto"></div>
            <iframe width="100%" height="270" src="https://www.youtube.com/embed/zqnNQHlR6SE?si=8-XxvXL6Uq8Q9nEC" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            <!-- <div class="mr-4 mt-4"><img src="~@/assets/images/SHUWOON/shop1_2.png" class="object-contain mx-auto"></div> -->
          </div>
          <router-link :to="{ name: 'detail', params: { category: 'magazine', id: 9547 } }" target="_blank" class="w-full px-3 block">
            <div class="mr-4 mt-4"><img src="~@/assets/images/SHUWOON/shop4_1.png" class="object-contain hidden md:block"></div>
            <div class="mr-4 mt-4"><img src="~@/assets/images/SHUWOON/shop4_1_m.png" class="object-contain md:hidden"></div>
          </router-link>
        </div>
        <router-link :to="{ name: 'detail', params: { category: 'magazine', id: 9547 } }" class="mt-4 block">
          <img src="~@/assets/images/SHUWOON/more.png" class="object-contain">
        </router-link>
      </div>
    </div>
    <div class="plan5 max-w-scoped mx-auto flex items-stretch mb-20 md:mb-24 px-2">
      <div class="left_line flex flex-col relative w-16 md:w-24">
        <div class="absolute left_line_class"><img src="~@/assets/images/SHUWOON/classN3N2.png" class="object-contain mx-auto"></div>
        <div class="absolute left_line_title"><img src="~@/assets/images/SHUWOON/video_title.png" class="object-contain mx-auto"></div>
      </div>
      <div class="plan5_inner flex-1 h-auto">
        <div class="flex flex-col md:flex-row mb-4 pt-4 ml-3 md:ml-0">
          <div class="mr-3 mb-2 md:mb-0"><img src="~@/assets/images/SHUWOON/title05.png" class="object-contain md:mx-auto"></div>
          <div class=""><img src="~@/assets/images/SHUWOON/title05_solgan.png" class="object-contain md:mx-auto hidden md:block"></div>
          <div class=""><img src="~@/assets/images/SHUWOON/title05_solgan_m.png" class="object-contain md:mx-auto md:hidden"></div>
        </div>
        <div class="flex flex-col md:flex-row mb-4 px-3">
          <div class="mr-4 mb-4 md:mb-0"><img src="~@/assets/images/SHUWOON/img05.png" class="object-contain"></div>
          <div class="">
            <img src="~@/assets/images/SHUWOON/img05_text.png" class="object-contain mx-auto hidden md:block">
            <img src="~@/assets/images/SHUWOON/img05_text_m.png" class="object-contain md:hidden">
          </div>
        </div>
        <div class="flex flex-wrap">
          <div class="w-full md:w-1/2 px-3 mb-4 md:mb-0">
            <div class="mr-4 mb-4"><img src="~@/assets/images/SHUWOON/film05_1.png" class="object-contain md:mx-auto"></div>
            <iframe width="100%" height="270" src="https://www.youtube.com/embed/FTmWY7PEIcI?si=qSGznVyfSV6wO8oZ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
          <div class="w-full md:w-1/2 px-3">
            <div class="mr-4 mb-4"><img src="~@/assets/images/SHUWOON/film05_2.png" class="object-contain md:mx-auto"></div>
            <iframe width="100%" height="270" src="https://www.youtube.com/embed/jzpAx94aszA?si=qT4Q91VOiytCzP5b" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
          <router-link :to="{ name: 'detail', params: { category: 'magazine', id: 9548 } }" target="_blank" class="w-full px-3">
            <div class="mr-4 mt-4"><img src="~@/assets/images/SHUWOON/shop5_1.png" class="object-contain hidden md:block"></div>
            <div class="mr-4 mt-4"><img src="~@/assets/images/SHUWOON/shop5_1_m.png" class="object-contain md:hidden"></div>
          </router-link>
        </div>
        <router-link :to="{ name: 'detail', params: { category: 'magazine', id: 9548 } }" target="_blank" class="mt-4 block">
          <img src="~@/assets/images/SHUWOON/more.png" class="object-contain">
        </router-link>
      </div>
    </div>
    <div class="footer py-12">
      <div class="max-w-scoped mx-auto px-8 lg::px-0">
        <div class="flex justify-center items-center mb-6">
          <div class="pr-6 hidden md:block"><img src="~@/assets/images/SHUWOON/footer_arrow_L.png" class="object-contain mx-auto"></div>
          <p class="text-center md:text-xl font-semibold">詳細活動內容以LiveABC官網發布為主。本公司保留活動修改、變更之權利。</p>
          <div class="pl-6 hidden md:block"><img src="~@/assets/images/SHUWOON/footer_arrow_R.png" class="object-contain mx-auto"></div>
        </div>
        <router-link :to="{ name: 'index' }" class="block"><img src="~@/assets/images/SHUWOON/logo.png" class="object-contain block mx-auto"></router-link>
      </div>
    </div>
  </div>
</template>
<script>
import jump from 'jump.js'
export default {
  name: 'shuwoon',
  metaInfo () {
    return {
      title: 'LiveABC X 旭文日本語學院',
      titleTemplate: null
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    toTop (n) {
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.max-w-scoped {
  max-width: 1120px;
}
.bg-light-blue {
  background-color: #EFF6FF;
}
.shadow_line {
  box-shadow: 0px 4px 4px 0px #00000040;
}
.advantage_img {
  left: 1%;
}
.left_line {
  &:before {
    content: "";
    display: block;
    top: 0;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    background: #B2CCFF;
    height: 100%;
    width: 4px;
  }
  &:after {
    content: "";
    display: block;
    bottom: -2%;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;

    background: #B2CCFF;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    @media (max-width: 640px) {
      height: 25px;
      width: 25px;
      bottom: -1%;
    }
  }
  .left_line_class {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 90px;
    height: 90px;
    @media (max-width: 640px) {
      width: 80px;
      height: 80px;
    }
  }
  .left_line_title {
    bottom: 25%;
    left: 50%;
    transform: translateX(-50%);
  }
}

.footer {
  background-image: url('~@/assets/images/SHUWOON/footer_bg.png');
  background-size: contain;
}
</style>
